var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#650813;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,0c12.2,0,22,9.9,22,22c0,12.1-9.9,22-22,22C9.9,44,0,34.1,0,22C0,9.9,9.9,0,22,0z M40.9,22 c0-10.4-8.4-18.9-18.8-18.9C11.6,3.1,3.2,11.5,3.1,22c0,10.4,8.4,18.9,18.8,18.9C32.4,40.9,40.8,32.5,40.9,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,18.4c0,1.4,0,2.9,0,4.3c0,1.3-0.7,2.1-1.8,2.1c-1,0-1.7-0.8-1.7-2c0-2.9,0-5.9,0-8.8 c0-1.2,0.7-1.9,1.7-1.9c1.1,0,1.7,0.8,1.8,2C23.7,15.5,23.7,17,23.7,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,31.9c-1,0-1.8-0.7-1.8-1.7c0-1,0.8-1.8,1.8-1.8c0.9,0,1.7,0.8,1.7,1.8C23.7,31.2,23,31.9,22,31.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.8bff29be3c677e1169fca19e1db81365.svg";
export { ForwardRef as ReactComponent };